module.exports = __webpack_public_path__ + "static/media/rakesly_bd.026e0b35.ttf";